<template>
    <div>
        <el-card>
            <div slot="header">
                <span class="top_title">出入库汇总</span>
            </div>
            <div class="searchItem">
                <div class="search">
                    <span class="searchtips">日期:</span>
                    <el-date-picker
                        v-model="searchDate.dateRan"
                        type="daterange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        style="width: 230px"
                        :editable="false"
                        value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                </div>
                <div class="search">
                    <span class="searchtips">仓库:</span>
                    <el-select
                        v-model="searchDate.wid"
                        placeholder=""
                        multiple
                        collapse-tags
                        clearable
                        @visible-change="$forceUpdate()"
                        style="width:160px"
                    >
                        <el-option
                            v-for="(item, index) in wList"
                            :key="index"
                            :value="item.id"
                            :label="item.name"
                            style="
                                height: 40px;
                                padding: 10px;
                                line-height: 20px;
                            "
                        />
                    </el-select>
                </div>
                <div class="search">
                    <span class="searchtips">商品:</span>
                    <el-input
                        v-model="searchDate.pname"
                        style="width:180px"
                        clearable
                    ></el-input>
                </div>
                <div class="search">
                    <span class="searchtips">颜色:</span>
                    <el-input
                        v-model="searchDate.color"
                        style="width:180px"
                        clearable
                    ></el-input>
                </div>
                <div class="search">
                    <span class="searchtips">尺码:</span>
                    <el-input
                        v-model="searchDate.size"
                        style="width:180px"
                        clearable
                    ></el-input>
                </div>
                <div class="search">
                    <el-button type="primary" icon="el-icon-search" @click="searchOrder()">查询</el-button>
                </div>
                <div class="search">
                    <el-button
                        type="primary"
                        icon="el-icon-printer"
                        @click="print"
                        v-if="$common.checkWindowsEnv()"
                        >打印</el-button>
                    <el-button
                        type='primary'
                        icon="el-icon-document"
                        @click="changePdf"
                    >导出</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                v-loading="loading"
                style="
                    width: 100%;
                    margin-top: 20px;
                    margin-bottom: 20px;
                "
                border
                show-summary
                :summary-method="getSummaries"
            >
                <el-table-column label="商品"  width="200px">
                    <template slot-scope="props">
                        <span>{{props.row.pnumber+"_"+props.row.pname}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="规格" width="100px">
                    <template slot-scope="props">
                        <span>{{props.row.color?(props.row.color+"/"+props.row.size):"默认"}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="price" label="单价(元)">
                </el-table-column>
                <el-table-column label="包装单位">
                    <template slot-scope="props">
                        <span>{{props.row.unit+$global.unit+'/'+$global.pack}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="wname" label="仓库">
                </el-table-column>
                <el-table-column prop="indesc" label="商品入库" width='120px'>
                </el-table-column>
                <el-table-column prop="inmoney" label="入库总价(元)" width='120px'>
                </el-table-column>
                <el-table-column prop="outdesc" label="商品出库" width='120px'>
                </el-table-column>
                <el-table-column prop="outmoney" label="出库总价(元)" width='120px'>
                </el-table-column>
            </el-table>
            <el-pagination
                style="text-align: right"
                @size-change="handleSizeChange($event)"
                @current-change="handleCurrentChange($event)"
                :current-page="currentPage"
                :page-sizes="[20, 50, 120, 250]"
                :page-size="cp_pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :pager-count="5"
            >
            </el-pagination>
        </el-card>
        <ReportOrder ref="roder"></ReportOrder>
        <edit-share ref="share"></edit-share>
    </div>
</template>

<script>
import ReportOrder from '@/components/printshare/reportorder.vue';
import editShare from '@/components/printshare/edit_share';
export default {
    components:{
        ReportOrder,editShare
    },
    data() {
        return {
            loading:false,
            controlModel:0,
            searchDate: {
                dateRan: [],
                pname:"",
                wid:'',
                color:'',
                size:'',
            },
            pickerOptions: {shortcuts:this.$common.initPickerOptions()},
            wList:[],
            currentPage: 1,
            cp_pagesize: 20,
            total: 100,
            tableData: [],
            totalin:0,
			totalinprice:0,
			totalout:0,
			totaloutprice:0,
            searchObj:{},
        };
    },
    created() {
        this.searchObj = {
            page: this.currentPage,
            limit: this.cp_pagesize,
        };
        this.sumRecord();
        this.getWareHouse();
    },
    methods: {
        print(){
			let array = [];
			let cmp = this.$global.cmpId.cmp;
			array.push(cmp);
			this.$nextTick(()=>{
				this.$refs.roder.extraOpen(10,array);
			})
		},
		changePdf(){
			let array = [1];
			this.$nextTick(()=>{
				this.$refs.share.openList(array,10,this.searchObj);
			})
		},
        getSummaries(param){
            let sums = [];
            for(let index=0;index<12;index++){
                if(index==0){
                    sums[index] = '合计';
                }else if(index==5){
                    sums[index] = this.totalin;
                }else if(index==6){
                    sums[index] = this.totalinprice;
                }else if(index==7){
                    sums[index] = this.totalout;
                }else if(index==8){
                    sums[index] = this.totaloutprice;
                }else{
                    sums[index] = "";
                }
            }
            return sums;
        },
        getWareHouse(){
            this.$api.listWareHouse().then((res)=>{
                if(res.data.code==1){
                    let data =res.data.data;
                    this.wList = data;
                }
            })
        },
        searchOrder(){
            this.searchObj = {
                page: 1,
                limit: this.cp_pagesize,
            };
            this.currentPage = 1;
            if(this.searchDate.dateRan&&this.searchDate.dateRan.length>=2){
                this.searchObj.start = this.searchDate.dateRan[0];
                this.searchObj.end = this.searchDate.dateRan[1];
            }
            if(this.searchDate.pname){
                this.searchObj.pname = this.searchDate.pname;
            }
            if(this.searchDate.color){
                this.searchObj.color = this.searchDate.color;
            }
            if(this.searchDate.size){
                this.searchObj.size = this.searchDate.size;
            }
            if(this.searchDate.wid.length){
                this.searchObj.wid = this.searchDate.wid.join(',');
            }
            this.sumRecord();
        },
        handleSizeChange(val) {
            this.cp_pagesize = val;
            this.searchOrder();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.searchObj.page = val;
            this.sumRecord();
        },
        sumRecord() {
            this.loading = true;
            this.$api.sumRecord(this.searchObj).then((res) => {
                if (res.data.code == 1) {
                    this.tableData = [];
                    this.total = res.data.count;
                    let data = res.data.data.list;
                    let totalData = res.data.data.sum;
                    if(data!=null&&data.length>0){
                        data.forEach(e => {
                            if(e.in){
								e.indesc =e.inamount+"件";
								if(e.inparts>0){
									e.indesc+=e.inparts+"双";
                                }
                                e.indesc = this.$common.changeNumDesc(e,'inamount','inparts','in');
							}
							if(e.out){
								e.out = -e.out;
								e.outamount = -e.outamount;
                                e.outparts = -e.outparts;
                                e.outmoney = -e.outmoney;
                                e.outdesc = this.$common.changeNumDesc(e,'outamount','outparts','out');
							}
                            this.tableData.push(e);
                        });
                    }
                    this.totalin = this.$common.changeNumDesc(totalData,'suminamount','suminparts','sumin');
                    this.totalinprice = totalData.sumpricein?totalData.sumpricein:0;
                    totalData.sumout = -totalData.sumout;
                    totalData.sumoutamount = -totalData.sumoutamount;
                    totalData.sumoutparts = -totalData.sumoutparts;
                    this.totalout = this.$common.changeNumDesc(totalData,'sumoutamount','sumoutparts','sumout');
					this.totaloutprice = totalData.sumpriceout?-totalData.sumpriceout:0;
                    this.loading = false;
                }
            });
        },
    },
};
</script>
